import { defineAction } from '~/prix'
import { z } from 'zod'
import communityGardenBeneficiaryCreateAction from './communityGardenBeneficiaryCreate.action.json' with { type: 'json' }
import { communityGardenBeneficiaryObject } from '../../communityGarden/communityGardenBeneficiaryObject'

const communityGardenBeneficiaryCreateDefinition = defineAction({
  ...communityGardenBeneficiaryCreateAction,

  input: communityGardenBeneficiaryObject
    .pick({ id: true, communityGardenId: true, citizenId: true })
    .extend({ id: communityGardenBeneficiaryObject.shape.id.nullish() }),
  output: z.object({ id: communityGardenBeneficiaryObject.shape.id }),
})

export default communityGardenBeneficiaryCreateDefinition
